import { Dispatch, SetStateAction } from 'react';

import { useStorage } from './use-storage';

export function useLocalStorage<T>(key: string, initialValue: T): [T, Dispatch<SetStateAction<T>>] {
  return useStorage<T>(key, initialValue, global.localStorage);
}
